var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useCallback, useRef } from 'react';
import { pickTokenFromStorage, clearAllAuthTokens } from '../utils/tokenStorage';
function readJwtRoleCodesFromToken(token) {
    try {
        if (!(token === null || token === void 0 ? void 0 : token.includes('.')))
            return [];
        var part = token.split('.')[1];
        if (!part)
            return [];
        var b64 = part.replace(/-/g, '+').replace(/_/g, '/');
        var pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4));
        var payload = JSON.parse(atob(b64 + pad));
        if (!Array.isArray(payload.roles))
            return [];
        return payload.roles.filter(function (x) { return typeof x === 'string' && !!x.trim(); });
    }
    catch (_a) {
        return [];
    }
}
/**
 * 将 msLogin POST /api/auth/verify 的 payload 规范为与登录接口一致的 mslogin_user 结构，
 * 保证 roles、rolePermissions 写入本地后，侧边栏/调试里能看到全部角色（JWT 不含 rolePermissions）。
 */
/**
 * msOrg 生产：Nginx 将 `/api/mslogin-proxy/*` 反代到本机 msLogin，避免浏览器直连 `login.homaxs.com` 触发 CORS。
 * 与 msOrg `authWindowGlobals` / `netConfig.shouldMsLoginVerifyViaOrgOrigin` 一致；构建时若注入了
 * `REACT_APP_API_BASE_URL=https://login.homaxs.com/api`，仅靠 window 可能被覆盖顺序影响，此处再兜底。
 */
function resolveMsOrgHomaxsVerifyProxy(apiBaseUrl, authEndpoint) {
    var _a, _b;
    if (typeof window === 'undefined' || !((_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname)) {
        return { apiBaseUrl: apiBaseUrl, authEndpoint: authEndpoint };
    }
    var raw = ((typeof process !== 'undefined' && ((_b = process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_MSLOGIN_VERIFY_VIA_ORG_ORIGIN)) ||
        '')
        .trim()
        .toLowerCase();
    if (raw === 'false' || raw === '0' || raw === 'no') {
        return { apiBaseUrl: apiBaseUrl, authEndpoint: authEndpoint };
    }
    var h = window.location.hostname.toLowerCase();
    if (h === 'org.homaxs.com' || h === 'msorg.homaxs.com') {
        var origin = window.location.origin.replace(/\/$/, '');
        return {
            apiBaseUrl: "".concat(origin, "/api"),
            authEndpoint: '/mslogin-proxy/auth/verify',
        };
    }
    return { apiBaseUrl: apiBaseUrl, authEndpoint: authEndpoint };
}
function normalizeUserFromMsLoginVerifyPayload(payload, accessToken) {
    var _a, _b, _c, _d, _e, _f;
    var id = String((_c = (_b = (_a = payload.adminId) !== null && _a !== void 0 ? _a : payload.userId) !== null && _b !== void 0 ? _b : payload.id) !== null && _c !== void 0 ? _c : '');
    var account = String((_e = (_d = payload.account) !== null && _d !== void 0 ? _d : payload.username) !== null && _e !== void 0 ? _e : '');
    var fromPayload = Array.isArray(payload.roles) ? payload.roles : [];
    var fromJwt = readJwtRoleCodesFromToken(accessToken);
    var roles = __spreadArray([], new Set(__spreadArray(__spreadArray([], fromPayload, true), fromJwt, true)), true);
    return {
        id: id,
        account: account,
        name: account,
        roles: roles,
        roleDetails: Array.isArray(payload.roleDetails) ? payload.roleDetails : [],
        rolePermissions: Array.isArray(payload.rolePermissions)
            ? payload.rolePermissions
            : [],
        permissions: Array.isArray(payload.permissions) ? payload.permissions : [],
        isSuperAdmin: !!((_f = payload.isSuperAdmin) !== null && _f !== void 0 ? _f : payload.is_super_admin),
    };
}
/**
 * 首帧同步从 localStorage 恢复登录态，避免每个 AuthGuard 在 useEffect 前长期 loading: true
 * （msOrg 等应用在路由级多次挂载 AuthGuard，与 App 顶层各自一份 useAuth 状态）。
 */
function readInitialAuthFromStorage() {
    var _a;
    var base = {
        isAuthenticated: false,
        token: null,
        user: null,
        loading: true,
        error: null,
        permissions: [],
    };
    try {
        var token = pickTokenFromStorage();
        if (!token) {
            return __assign(__assign({}, base), { loading: false });
        }
        var cachedUser = (_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('mslogin_user');
        if (!cachedUser) {
            return __assign(__assign({}, base), { token: token, loading: true });
        }
        try {
            var userData = JSON.parse(cachedUser);
            var permissions = (Array.isArray(userData.permissions)
                ? userData.permissions
                : []);
            return {
                isAuthenticated: true,
                token: token,
                user: userData,
                loading: false,
                error: null,
                permissions: permissions,
            };
        }
        catch (_b) {
            return __assign(__assign({}, base), { token: token, loading: true });
        }
    }
    catch (_c) {
        return base;
    }
}
// 认证Hook
export var useAuth = function (config) {
    // 完全禁用调试信息输出
    // if (process.env.NODE_ENV === 'development') {
    //   console.log('[useAuth] Hook 开始初始化');
    // }
    var _a = useState(readInitialAuthFromStorage), authState = _a[0], setAuthState = _a[1];
    // 防重复调用标志
    var _b = useState(false), isChecking = _b[0], setIsChecking = _b[1];
    // 防抖机制，避免频繁认证检查
    var debounceRef = useRef(null);
    var lastCheckRef = useRef(0);
    // 完全禁用调试信息输出
    // if (process.env.NODE_ENV === 'development') {
    //   console.log('[useAuth] 初始状态:', authState);
    // }
    // 检查认证状态
    var checkAuth = useCallback(function (silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var now, token, apiBaseUrl, hostname, authEndpoint, finalApiBaseUrl, proxied, response, result, userData, normalized, verifyError_1, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // 防止重复调用
                        if (isChecking) {
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 认证检查正在进行中，跳过重复调用');
                            // }
                            return [2 /*return*/];
                        }
                        now = Date.now();
                        if (now - lastCheckRef.current < 2000) { // 增加到2秒内不重复检查
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 防抖机制：跳过频繁的认证检查');
                            // }
                            return [2 /*return*/];
                        }
                        // 完全禁用调试信息输出
                        // if (process.env.NODE_ENV === 'development') {
                        //   console.log('[useAuth] checkAuth 函数被调用');
                        // }
                        setIsChecking(true);
                        // 静默模式下不设置loading，避免页面闪烁
                        if (!silent) {
                            setAuthState(function (prev) { return (__assign(__assign({}, prev), { loading: true, error: null })); });
                        }
                        lastCheckRef.current = now;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, 8, 9]);
                        token = pickTokenFromStorage();
                        // 完全禁用调试信息输出
                        // if (process.env.NODE_ENV === 'development') {
                        //   console.log('[useAuth] Token检查结果:', {
                        //     hasToken: !!token,
                        //     tokenLength: token ? token.length : 0,
                        //     tokenPreview: token ? token.substring(0, 20) + '...' : 'null',
                        //     localStorage: {
                        //       token: localStorage.getItem('token') ? 'exists' : 'null',
                        //       mslogin_token: localStorage.getItem('mslogin_token') ? 'exists' : 'null'
                        //     },
                        //     sessionStorage: {
                        //       token: sessionStorage.getItem('token') ? 'exists' : 'null',
                        //       mslogin_token: sessionStorage.getItem('mslogin_token') ? 'exists' : 'null'
                        //     }
                        //   });
                        // }
                        if (!token) {
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 没有找到token，认证失败');
                            // }
                            setAuthState({
                                isAuthenticated: false,
                                token: null,
                                user: null,
                                loading: false,
                                error: null,
                                permissions: [],
                            });
                            return [2 /*return*/];
                        }
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 5, , 6]);
                        apiBaseUrl = void 0;
                        // 混合模式：useAuth 只使用环境变量配置自己的API地址
                        // 服务发现应该用于获取其他微服务的地址，而不是自己的地址
                        if ((config === null || config === void 0 ? void 0 : config.enableServiceDiscovery) && (config === null || config === void 0 ? void 0 : config.serviceName)) {
                            console.warn('[useAuth] 警告：服务发现不应用于获取当前微服务自己的API地址');
                            console.warn('[useAuth] 建议：请设置环境变量 REACT_APP_API_BASE_URL 或使用 enableServiceDiscovery: false');
                        }
                        // 始终使用环境变量配置自己的API地址
                        apiBaseUrl = (typeof window !== 'undefined' && window.REACT_APP_API_BASE_URL) ||
                            process.env.REACT_APP_API_BASE_URL ||
                            (typeof window !== 'undefined' && window.REACT_APP_API_URL) ||
                            process.env.REACT_APP_API_URL || '';
                        // 启用调试信息输出
                        if (process.env.NODE_ENV === 'development') {
                            console.log('[useAuth] 环境变量检查:', {
                                window_REACT_APP_API_BASE_URL: (typeof window !== 'undefined' && window.REACT_APP_API_BASE_URL),
                                process_env_REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
                                window_REACT_APP_API_URL: (typeof window !== 'undefined' && window.REACT_APP_API_URL),
                                process_env_REACT_APP_API_URL: process.env.REACT_APP_API_URL,
                                finalApiBaseUrl: apiBaseUrl
                            });
                        }
                        // 如果环境变量未配置，根据当前域名判断API地址
                        if (!apiBaseUrl) {
                            if (typeof window !== 'undefined' && window.location) {
                                hostname = window.location.hostname;
                                // 生产环境：根据域名判断使用统一的后端API地址
                                if (hostname.includes('homaxs.com') || hostname.includes('idtree.cn')) {
                                    // 生产环境统一使用 www.homaxs.com 作为后端API地址
                                    apiBaseUrl = 'https://www.homaxs.com';
                                    console.log('[useAuth] 生产环境，使用统一后端API地址:', apiBaseUrl);
                                }
                                else {
                                    // 开发环境或本地环境，使用当前域名
                                    apiBaseUrl = "".concat(window.location.origin);
                                    console.log('[useAuth] 环境变量未配置，使用当前域名:', apiBaseUrl);
                                }
                            }
                            else {
                                // 开发环境 fallback
                                console.warn('[useAuth] 环境变量未配置，使用开发环境默认配置');
                                apiBaseUrl = 'http://localhost:50090';
                            }
                        }
                        // 检查是否有重复的 /api
                        if (apiBaseUrl.endsWith('/api/api')) {
                            console.error('[useAuth] 检测到重复的 /api 路径，自动修复:', apiBaseUrl);
                            apiBaseUrl = apiBaseUrl.replace('/api/api', '/api');
                        }
                        authEndpoint = (typeof window !== 'undefined' && window.REACT_APP_AUTH_ENDPOINT) ||
                            process.env.REACT_APP_AUTH_ENDPOINT ||
                            '/api/auth/verify';
                        finalApiBaseUrl = apiBaseUrl;
                        proxied = resolveMsOrgHomaxsVerifyProxy(finalApiBaseUrl, authEndpoint);
                        finalApiBaseUrl = proxied.apiBaseUrl;
                        authEndpoint = proxied.authEndpoint;
                        // 启用调试信息输出
                        if (process.env.NODE_ENV === 'development') {
                            console.log('[useAuth] 使用API配置:', { apiBaseUrl: apiBaseUrl, finalApiBaseUrl: finalApiBaseUrl, authEndpoint: authEndpoint });
                            console.log('[useAuth] 发送认证请求到:', "".concat(finalApiBaseUrl).concat(authEndpoint));
                            console.log('[useAuth] 认证请求token:', token ? "".concat(token.substring(0, 20), "...") : 'null');
                        }
                        return [4 /*yield*/, fetch("".concat(finalApiBaseUrl).concat(authEndpoint), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({ token: token }),
                            })];
                    case 3:
                        response = _d.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        result = _d.sent();
                        // 启用调试信息输出
                        if (process.env.NODE_ENV === 'development') {
                            console.log('[useAuth] 认证响应结果:', result);
                            console.log('[useAuth] 响应数据结构:', {
                                success: result.success,
                                data: result.data,
                                dataValid: (_a = result.data) === null || _a === void 0 ? void 0 : _a.valid,
                                dataAdmin: (_b = result.data) === null || _b === void 0 ? void 0 : _b.admin,
                                dataAdminKeys: ((_c = result.data) === null || _c === void 0 ? void 0 : _c.admin) ? Object.keys(result.data.admin) : 'no admin data'
                            });
                        }
                        if (result.success && result.data.valid) {
                            // 启用调试信息输出
                            if (process.env.NODE_ENV === 'development') {
                                console.log('[useAuth] 认证成功，设置认证状态');
                                console.log('[useAuth] 用户信息:', result.data.payload || result.data.admin);
                            }
                            userData = result.data.payload || result.data.admin;
                            if (!userData) {
                                throw new Error('认证响应中缺少用户数据');
                            }
                            normalized = normalizeUserFromMsLoginVerifyPayload(userData, token);
                            try {
                                localStorage.setItem('mslogin_user', JSON.stringify(normalized));
                                localStorage.setItem('token', token);
                                localStorage.setItem('mslogin_token', token);
                                sessionStorage.setItem('mslogin_token', token);
                            }
                            catch (_e) {
                                /* ignore */
                            }
                            setAuthState({
                                isAuthenticated: true,
                                token: token,
                                user: normalized,
                                loading: false,
                                error: null,
                                permissions: normalized.permissions || [],
                            });
                            // 完全禁用调试信息输出
                            // if (process.env.NODE_ENV === 'development') {
                            //   console.log('[useAuth] 认证状态已设置:', {
                            //     isAuthenticated: true,
                            //     hasToken: !!token,
                            //     hasUser: !!result.data.admin
                            //   });
                            // }
                        }
                        else {
                            // Token 无效：须同时清除 token 与 mslogin_token，否则仅清 token 会残留旧 mslogin_token，
                            // 与后续「优先 mslogin」的 API 组合后永远发过期 JWT。
                            clearAllAuthTokens();
                            try {
                                localStorage.removeItem('mslogin_user');
                            }
                            catch (_f) {
                                /* ignore */
                            }
                            setAuthState({
                                isAuthenticated: false,
                                token: null,
                                user: null,
                                loading: false,
                                error: 'Token已过期或无效',
                                permissions: [],
                            });
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        verifyError_1 = _d.sent();
                        // 验票请求异常：不再假登录；清空令牌，避免界面显示已登录但 API 一律 401
                        clearAllAuthTokens();
                        try {
                            localStorage.removeItem('mslogin_user');
                        }
                        catch (_g) {
                            /* ignore */
                        }
                        setAuthState({
                            isAuthenticated: false,
                            token: null,
                            user: null,
                            loading: false,
                            error: verifyError_1 instanceof Error ? verifyError_1.message : '认证验证失败',
                            permissions: [],
                        });
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        error_1 = _d.sent();
                        // 静默模式下，验证失败时不更新状态，保持当前状态
                        if (!silent) {
                            setAuthState({
                                isAuthenticated: false,
                                token: null,
                                user: null,
                                loading: false,
                                error: error_1 instanceof Error ? error_1.message : '认证检查失败',
                                permissions: [],
                            });
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        setIsChecking(false);
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    }, [isChecking]);
    // 登录
    var login = useCallback(function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var apiBaseUrl, authEndpoint, proxiedLogin, response, userData, error_2, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 9, , 10]);
                    localStorage.setItem('token', token);
                    localStorage.setItem('mslogin_token', token);
                    sessionStorage.setItem('mslogin_token', token);
                    if (!!isChecking) return [3 /*break*/, 8];
                    setIsChecking(true);
                    setAuthState(function (prev) { return (__assign(__assign({}, prev), { loading: true, error: null })); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    apiBaseUrl = (typeof window !== 'undefined' && window.REACT_APP_API_BASE_URL) ||
                        process.env.REACT_APP_API_BASE_URL ||
                        (typeof window !== 'undefined' && window.REACT_APP_API_URL) ||
                        process.env.REACT_APP_API_URL || 'http://localhost:50090/api';
                    authEndpoint = (typeof window !== 'undefined' && window.REACT_APP_AUTH_ENDPOINT) ||
                        process.env.REACT_APP_AUTH_ENDPOINT ||
                        '/api/auth/verify';
                    proxiedLogin = resolveMsOrgHomaxsVerifyProxy(apiBaseUrl, authEndpoint);
                    apiBaseUrl = proxiedLogin.apiBaseUrl;
                    authEndpoint = proxiedLogin.authEndpoint;
                    return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(authEndpoint), {
                            method: 'GET',
                            headers: {
                                'Authorization': "Bearer ".concat(token),
                                'Content-Type': 'application/json',
                            },
                        })];
                case 2:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    userData = _b.sent();
                    setAuthState({
                        isAuthenticated: true,
                        token: token,
                        loading: false,
                        error: null,
                        user: userData.user || userData,
                        permissions: ((_a = (userData.user || userData)) === null || _a === void 0 ? void 0 : _a.permissions) || [],
                    });
                    return [3 /*break*/, 5];
                case 4: throw new Error('认证失败');
                case 5: return [3 /*break*/, 8];
                case 6:
                    error_2 = _b.sent();
                    setAuthState(function (prev) { return (__assign(__assign({}, prev), { isAuthenticated: false, loading: false, error: error_2 instanceof Error ? error_2.message : '认证检查失败', permissions: [] })); });
                    return [3 /*break*/, 8];
                case 7:
                    setIsChecking(false);
                    return [7 /*endfinally*/];
                case 8: return [3 /*break*/, 10];
                case 9:
                    error_3 = _b.sent();
                    setAuthState(function (prev) { return (__assign(__assign({}, prev), { loading: false, error: error_3 instanceof Error ? error_3.message : '登录失败', permissions: [] })); });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [isChecking]);
    // 登出
    var logout = useCallback(function () {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        localStorage.removeItem('mslogin_token');
        sessionStorage.removeItem('mslogin_token');
        localStorage.removeItem('mslogin_user');
        localStorage.removeItem('mslogin_refresh_token');
        setAuthState({
            isAuthenticated: false,
            token: null,
            user: null,
            loading: false,
            error: null,
            permissions: [],
        });
    }, []);
    useEffect(function () {
        // 先检查本地缓存，如果有用户信息且token存在，先使用缓存，避免立即显示loading
        var token = localStorage.getItem('token') ||
            sessionStorage.getItem('token') ||
            localStorage.getItem('mslogin_token') ||
            sessionStorage.getItem('mslogin_token');
        var cachedUser = localStorage.getItem('mslogin_user');
        // 如果有token和缓存的用户信息，先使用缓存，避免页面闪烁
        if (token && cachedUser) {
            try {
                var userData = JSON.parse(cachedUser);
                var permissions = userData.permissions || [];
                // 先设置缓存状态，不显示loading
                setAuthState({
                    isAuthenticated: true,
                    token: token,
                    user: userData,
                    loading: false,
                    error: null,
                    permissions: permissions,
                });
                // 然后在后台静默验证token（不显示loading）
                // 防抖执行认证检查
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current);
                }
                debounceRef.current = setTimeout(function () {
                    // 静默验证，不设置loading状态
                    checkAuth(true).catch(function () {
                        // 验证失败时保持缓存状态，不强制跳转
                    });
                }, 300); // 短延迟后台验票，避免与首屏数据请求抢连接
                return function () {
                    if (debounceRef.current) {
                        clearTimeout(debounceRef.current);
                    }
                };
            }
            catch (error) {
                // 缓存解析失败，继续正常流程
                console.warn('[useAuth] 缓存用户信息解析失败，使用正常验证流程');
            }
        }
        // 没有缓存时，执行正常认证检查
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(function () {
            checkAuth();
        }, 0); // 无本地用户缓存时尽快验票，避免首屏多等半秒
        return function () {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []); // 移除 checkAuth 依赖，避免循环依赖
    // 权限检查函数
    var hasPermission = useCallback(function (permission) {
        if (authState.permissions.includes('*'))
            return true;
        return authState.permissions.includes(permission);
    }, [authState.permissions]);
    var hasAnyPermission = useCallback(function (permissions) {
        if (authState.permissions.includes('*'))
            return true;
        return permissions.some(function (permission) { return authState.permissions.includes(permission); });
    }, [authState.permissions]);
    var hasAllPermissions = useCallback(function (permissions) {
        if (authState.permissions.includes('*'))
            return true;
        return permissions.every(function (permission) { return authState.permissions.includes(permission); });
    }, [authState.permissions]);
    return __assign(__assign({}, authState), { checkAuth: checkAuth, login: login, logout: logout, hasPermission: hasPermission, hasAnyPermission: hasAnyPermission, hasAllPermissions: hasAllPermissions });
};
